import { Collapse } from './collapse';
export class SubFeaturesEqualHeight {
    constructor(scope) {
        this.scope = scope;
        this.subFeatureImageArray = [];
        this.selectedSubFeatureArray = [];
        this.imageLoadingCounter = 0;
        this.textModulesTextOnly = 0;
        if (!scope)
            return;
        this.selectedSubFeatureArray = Array.from(scope.querySelectorAll('.selected.has-sub-features'));
        this.subFeatureImageArray = Array.from(scope.querySelectorAll('.sub-features img.feature-image'));
        this.textModulesTextOnly = scope.querySelectorAll('.sub-features.extras div.feature-textbaustein-noimage').length;
        this.setImageLoadingMonitor();
    }
    setImageLoadingMonitor() {
        if (!this.subFeatureImageArray.length) {
            if (this.textModulesTextOnly > 0) {
                this.setEqualHeightForEachSubFeature();
            }
            new Collapse(this.scope, this);
            return;
        }
        this.imageLoadingCounter = 0;
        this.subFeatureImageArray.forEach((image) => {
            if (image.complete) {
                this.imageLoadFinished();
            }
            else {
                image.addEventListener('load', () => this.imageLoadFinished());
                image.addEventListener('error', () => this.imageLoadFinished());
            }
        });
    }
    imageLoadFinished() {
        this.imageLoadingCounter += 1;
        if (this.imageLoadingCounter === this.subFeatureImageArray.length) {
            this.setEqualHeightForEachSubFeature();
            new Collapse(this.scope, this);
        }
    }
    setEqualHeightForEachSubFeature() {
        this.selectedSubFeatureArray.forEach((rowSelected) => {
            const rowIndex = rowSelected.classList[0];
            const rowWrapperSelector = `.${rowIndex}.wrapper`;
            const rowWrapperElement = this.scope.querySelector(rowWrapperSelector);
            if (!rowWrapperElement)
                return;
            const subFeatureSelectedRows = Array.from(rowSelected.querySelectorAll('.sub-features'));
            const subFeatureWrapperRows = Array.from(rowWrapperElement.querySelectorAll('.sub-features'));
            subFeatureSelectedRows.forEach((subFeatureRow) => {
                const subFeatureIndex = subFeatureRow.classList[1];
                const matchingSubFeatures = subFeatureWrapperRows.filter((sf) => sf.classList.contains(subFeatureIndex));
                matchingSubFeatures.unshift(subFeatureRow);
                const maxOfHeight = this.getMaxOfHeight(matchingSubFeatures);
                this.setSubFeatureHeight(matchingSubFeatures, maxOfHeight);
            });
        });
    }
    getMaxOfHeight(subFeatures) {
        return Math.max(...subFeatures.map((sf) => sf.clientHeight));
    }
    setSubFeatureHeight(subFeatures, height) {
        subFeatures.forEach((sf) => (sf.style.height = `${height}px`));
    }
}
